import React, { useState } from 'react';

const ActressGallery = ({ images, className = "" }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeTab, setActiveTab] = useState('profile');

  if (!images || !images.all || images.all.length === 0) {
    return (
      <div className={`bg-white rounded-lg shadow-md p-6 ${className}`}>
        <h3 className="text-xl font-bold mb-4">画像ギャラリー</h3>
        <p className="text-gray-500">画像がありません</p>
      </div>
    );
  }

  const tabs = [
    { id: 'profile', label: 'プロフィール', images: images.profile || [] },
    { id: 'gallery', label: 'ギャラリー', images: images.gallery || [] },
    { id: 'cover', label: 'カバー', images: images.cover || [] }
  ].filter(tab => tab.images.length > 0);

  const currentImages = images[activeTab] || [];

  return (
    <>
      <div className={`bg-white rounded-lg shadow-md p-6 ${className}`}>
        <h3 className="text-xl font-bold mb-4">画像ギャラリー ({images.all.length})</h3>
        
        {/* Tabs */}
        {tabs.length > 1 && (
          <div className="flex space-x-1 mb-4">
            {tabs.map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-4 py-2 text-sm font-medium rounded-md ${
                  activeTab === tab.id
                    ? 'bg-blue-100 text-blue-700'
                    : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100'
                }`}
              >
                {tab.label} ({tab.images.length})
              </button>
            ))}
          </div>
        )}

        {/* Images Grid */}
        {currentImages.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {currentImages.map((image, index) => (
              <div
                key={image.id}
                className="relative cursor-pointer group overflow-hidden rounded-lg"
                onClick={() => setSelectedImage(image)}
              >
                <img
                  src={image.image_url}
                  alt={image.title || `Image ${index + 1}`}
                  className="w-full h-32 object-cover transition-transform group-hover:scale-105"
                />
                
                {image.is_primary && (
                  <div className="absolute top-2 left-2">
                    <span className="bg-blue-600 text-white text-xs px-2 py-1 rounded">
                      メイン
                    </span>
                  </div>
                )}
                
                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all" />
                
                {image.title && (
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-2">
                    <p className="text-white text-xs truncate">{image.title}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-500">このカテゴリーの画像がありません</p>
        )}
      </div>

      {/* Modal for image viewing */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div 
            className="bg-white rounded-lg max-w-4xl max-h-full overflow-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="p-4">
              <div className="flex justify-between items-start mb-4">
                <div>
                  <h4 className="text-lg font-bold">
                    {selectedImage.title || 'Image'}
                  </h4>
                  {selectedImage.description && (
                    <p className="text-gray-600 text-sm mt-1">
                      {selectedImage.description}
                    </p>
                  )}
                </div>
                <button
                  onClick={() => setSelectedImage(null)}
                  className="text-gray-400 hover:text-gray-600 text-2xl font-bold"
                >
                  ×
                </button>
              </div>
              
              <img
                src={selectedImage.image_url}
                alt={selectedImage.title || 'Image'}
                className="max-w-full max-h-[70vh] object-contain mx-auto"
              />
              
              <div className="mt-4 flex justify-between items-center text-sm text-gray-500">
                <div>
                  <span className="bg-gray-100 px-2 py-1 rounded text-xs">
                    {selectedImage.image_type}
                  </span>
                  {selectedImage.is_primary && (
                    <span className="ml-2 bg-blue-100 text-blue-700 px-2 py-1 rounded text-xs">
                      メイン画像
                    </span>
                  )}
                </div>
                
                {selectedImage.uploaded_by && (
                  <div>
                    アップロード者: {selectedImage.uploaded_by}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ActressGallery;